import React, { useState, useRef, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import {
  Modal,
  Box,
  Grid,
  Typography,
  IconButton,
  TableFooter,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import ImageListItem from '@mui/material/ImageListItem';
import { useLocation, useNavigate } from 'react-router-dom';
import inetlogo from '../../assets/images/inetlogo.png';
import addCommas from '../../utils/functions/commas';
import NotiAlertListDocument from '../NotiAlert/NotiAlertListDocument';
import axios from 'axios';
import JSZip from 'jszip';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const outerStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  p: 0,
  borderRadius: '15px',
  overflow: 'hidden',
  maxHeight: '90vh',
};

const innerStyle = {
  padding: 4,
  maxHeight: '90vh',
  overflowY: 'auto',
};

const setFont = {
  fontSize: '12px',
  color: (theme) => theme.palette.primary.main,
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const Doctype = {
  E_INVOICE: {
    NAME: 'e-invoice',
    API: 'e-invoice',
  },
  E_RECEIPT: {
    NAME: 'e-Receipt',
    API: 'e-receipt',
  },
};

function DrawerHistory({ openDrawer, setOpenDrawer, dataRowDetail }) {
  const pdfRef = useRef();
  const [isPdfCreating, setIsPdfCreating] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const methos = {
    closeButtonBeforeCreatePDF: async (msg) => {
      setIsPdfCreating(msg);
    },
  };
  const { t } = useTranslation();
  const downloadPDF = async () => {
    await methos.closeButtonBeforeCreatePDF(true);
    await html2canvas(pdfRef.current).then(async (canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      const pdfWidth = 210; // A4 ขนาด 210x297 มิลลิเมตร (แนะนำให้ใช้ค่าที่สอดคล้องกับขนาดกระดาษที่ต้องการ)
      const pdfHeight = 297; // Use getHeight() instead of getWidth() for height
      const margin = 10; // margin in millimeters

      const imgWidth = canvas.width;
      const imgHeight = canvas.height;

      const ratio = Math.min(
        (pdfWidth - 2 * margin) / imgWidth,
        (pdfHeight - 2 * margin) / imgHeight,
      );
      const imgX = margin;
      const imgY = margin;

      pdf.addImage(
        imgData,
        'PNG',
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio,
      );
      pdf.setFontSize(12);
      pdf.setTextColor('#000000');
      pdf.save('invoice.pdf');
      await methos.closeButtonBeforeCreatePDF(false);
    });
  };
  const [openListDocuments, setOpenListDocuments] = useState(false);
  const [listDocuments, setListDocuments] = useState(null);
  const [titleDocument, setTitleDocument] = useState('');
  const adjustTheFirstLetter = (text) =>
    text.replace(/\b\w/g, function (letter) {
      return letter.toUpperCase();
    });
  const eDocument = {
    downLoadZip: async (type, doc) => {
      const zip = new JSZip();
      const addFileToZip = (item, fileName) => {
        return new Promise((resolve, reject) => {
          if (!item.document) {
            resolve();
            return;
          }
          fetch(item.document)
            .then((response) => response.blob())
            .then((blob) => {
              zip.file(fileName, blob);
              resolve();
            })
            .catch((error) => reject(error));
        });
      };
      await Promise.all(
        doc.map(async (item) => {
          const fileName = `${type.toLocaleLowerCase()}-${item.invoice_no}.pdf`;
          await addFileToZip(item, fileName);
        }),
      );
      zip
        .generateAsync({ type: 'blob' })
        .then((blob) => {
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = `${type.toLocaleLowerCase()}.zip`;
          downloadLink.click();
          downloadLink.remove();
        })
        .catch((error) => console.error('Error generating zip file:', error))
        .finally(eDocument.closeDoc());
    },
    callApi: async (doc, type, api) => {
      try {
        const { data } = await axios.get(
          `${
            process.env.REACT_APP_API_URL
          }/reports/${api.toLocaleLowerCase()}?invoiceNo=${
            doc.invoice_no
          }&sorgcode=${doc.sorgcode}`,
        );
        if (type === Doctype.E_RECEIPT.NAME) {
          if (data.pdfStatus === 'ER') {
            throw `ไม่มีข้อมูล e-receipt`;
          }
          if (data.pdfUrl) {
            return {
              invoice_no: doc.invoice_no,
              document: `data:application/pdf;base64,${data.pdfUrl}`,
            };
          }
        } else if (
          type === Doctype.E_INVOICE.NAME ||
          type === Doctype.E_CREDIT_NOTE.NAME ||
          type === Doctype.ATTACHMENT.NAME
        ) {
          if (data.data.status === 'Not Found') {
            throw 'ไม่มีข้อมูล e-invoice';
          } else {
            const base64 = `data:application/pdf;base64,${data.data.File}`;
            return {
              invoice_no: doc.invoice_no,
              document: base64,
            };
          }
        }
      } catch (error) {
        return {
          invoice_no: doc.invoice_no,
          document: null,
        };
      }
    },
    closeDoc: () => {
      setOpenListDocuments(false);
    },
    main: async (type) => {
      try {
        const { result: RowDetail } = dataRowDetail;
        if (RowDetail.length == 0) {
          throw 'ไม่มีข้อมูล';
        }
        try {
          const eGet = RowDetail.map(async (item) => {
            const doc = {
              invoice_no: item.invoice_no,
              sorgcode: item.sorgcode,
            };
            return await eDocument.callApi(doc, type.NAME, type.API);
          });
          setListDocuments(await Promise.all(eGet));
          setTitleDocument(adjustTheFirstLetter(type.NAME));
          setOpenListDocuments(true);
        } catch (error) {
          console.log('Error:', error);
        }
      } catch (error) {
        console.error(error);
      }
    },
  };

  const [result, setResult] = useState([]);

  const data = {
    detail: [
      {
        title: t('app.totalAmountThb'),
        data: 'total_amount',
      },
      {
         title: t('app.vatThb'),
        data: 'total_vat',
      },
      {
       title: t('app.whtThb'),
        data: 'total_wht',
      },
      {
       title: t('app.discountThb'),
        data: 'total_discount',
      },
      {
           title: t('app.lateFeeThb'),
        data: 'total_fines',
      },
      {
          title: t('app.grandTotalThb'),
        data: 'total_pay_amount',
      },
    ],
    table: [
      {
        HeadName: t('app.saleOrder'),
        data: 'so_number',
      },
      {
          HeadName: t('app.invoiceNo'),
        data: 'invoice_no',
      },
      {
        HeadName: t('app.startDate'),
        data: 'period_start_date',
      },
      {
        HeadName: t('app.endDate'),
        data: 'period_end_date',
      },
      {
          HeadName: t('app.totalAmount'),
        data: 'amount',
      },
    ],
  };

  useEffect(() => {
    setResult(dataRowDetail?.result);
  }, [dataRowDetail]);

  const handleClose = () => {
    setOpenDrawer(false);
    //  setData({});
    navigate(location.pathname, { replace: true, state: {} });
  };

  return (
    <Modal
      open={openDrawer}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose(event, reason);
        }
      }}
      aria-labelledby="transaction-detail-title"
      aria-describedby="transaction-detail-description"
    >
      <Box sx={outerStyle}>
        <Box sx={innerStyle}>
          <Grid container ref={pdfRef} spacing={1}>
            <Grid container spacing={1}>
              <Grid item xs={3}>
                <ImageListItem sx={{ maxWidth: '100px' }}>
                  <img src={`${inetlogo}`} />
                </ImageListItem>
              </Grid>
              <Grid
                item
                xs={5}
                sx={{
                  textAlign: 'left',
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <Stack
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  className="mt-7"
                >
                  <Typography sx={{ fontSize: '10px' }}>
                    บริษัท อินเตอร์เน็ตประเทศไทย จำกัด (มหาชน)
                  </Typography>
                  <Typography sx={{ fontSize: '10px' }}>
                    1768 อาคารไทยซัมมิท ทาวเวอร์ ชั้น 10-12 และชั้น IT
                  </Typography>
                  <Typography sx={{ fontSize: '10px' }}>
                    ถ.เพชรบุรีตัดใหม่ แขวงบางกระปิ เขตห้วยขวาง กรุงเทพ 10310
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={4} sx={{ textAlign: 'right' }}>
                {!isPdfCreating && (
                  <div className="mt-4">
                    <IconButton
                      aria-label=""
                      size="small"
                      onClick={handleClose}
                      sx={{
                        border: '3px',
                        borderRadius: '50%',
                        borderStyle: 'solid',
                        borderColor: (theme) => theme.palette.grey[900],
                      }}
                    >
                      <CloseIcon
                        fontSize="inherit"
                        sx={{
                          color: (theme) => theme.palette.grey[900],
                          strokeWidth: 1.5,
                          stroke: 'currentcolor',
                        }}
                      />
                    </IconButton>
                  </div>
                )}
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid
                sx={{ textAlign: 'center', marginBottom: '10px' }}
                item
                xs={12}
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 'bold', color: '#545454' }}
                >
                  {t('app.paymentDetail')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={5}
                >
                  <Stack
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={0}
                  >
                    <Typography sx={{ fontSize: '12px' }}>
                      {t('app.customerCompanyName')}
                    </Typography>
                    <Typography sx={{ fontSize: '12px' }}>
                      {t('app.transactionRefNo')}
                    </Typography>
                    <Typography sx={{ fontSize: '12px' }}>
                      {t('app.description')}
                    </Typography>
                    <Typography sx={{ fontSize: '12px' }}>
                      {' '}
                      {t('app.to')}
                    </Typography>
                  </Stack>
                  <Stack
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={0}
                  >
                    <Typography sx={setFont}>
                      {dataRowDetail?.customer?.customer_name}
                    </Typography>
                    <Typography sx={setFont}>
                      {dataRowDetail?.order_id_ref}
                    </Typography>
                    <Typography sx={setFont}>
                      {dataRowDetail?.description}
                    </Typography>
                    <Typography sx={setFont}>
                      {dataRowDetail?.sorgcode}
                    </Typography>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <div className="mt-5">
                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: '10px',
                      border: '1px solid',
                      borderColor: (theme) => theme.palette.grey[400],
                      boxShadow: 'none',
                    }}
                  >
                    <Table sx={{}} size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          {data.table.map((item, i) => (
                            <StyledTableCell key={i} align="center">
                              {item.HeadName}
                            </StyledTableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {result?.map((value, index) => (
                          <TableRow key={index}>
                            {data.table.map((item, i) => (
                              <TableCell key={i} align="center">
                                {(() => {
                                  if (item.data === 'amount') {
                                    return addCommas(value?.[`${item.data}`]);
                                  } else if (
                                    item.data === 'period_start_date'
                                  ) {
                                    return dayjs(
                                      value?.[`${item.data}`],
                                    ).format('YYYY-MM-DD');
                                  } else if (item.data === 'period_end_date') {
                                    return dayjs(
                                      value?.[`${item.data}`],
                                    ).format('YYYY-MM-DD');
                                  } else {
                                    return value?.[`${item.data}`];
                                  }
                                })()}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                      {/* <TableFooter
                        sx={{
                          backgroundColor: (theme) =>
                            theme.palette.primary.main,
                        }}
                      >
                        <TableCell
                          sx={{ color: (theme) => theme.palette.common.white }}
                          align="center"
                        >
                          Total
                        </TableCell>
                        <TableCell
                          sx={{ color: (theme) => theme.palette.common.white }}
                          align="center"
                        >
                          Total
                        </TableCell>
                        <TableCell
                          sx={{ color: (theme) => theme.palette.common.white }}
                          align="center"
                        >
                          Total
                        </TableCell>
                      </TableFooter> */}
                    </Table>
                  </TableContainer>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <div className="mt-5">
                  <Typography
                    variant="h6"
                    sx={{
                      color: (theme) => theme.palette.success.dark,
                      fontWeight: 'bold',
                    }}
                  >
                    Detail
                  </Typography>
                  <TableContainer
                    component={Paper}
                    sx={{
                      border: '0.1px solid',
                      borderColor: (theme) => theme.palette.grey[400],
                      boxShadow: 'none',
                      marginTop: 3,
                    }}
                  >
                    <Table sx={{}} size="small" aria-label="a dense table">
                      <TableBody>
                        {data.detail.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell align="left">{item.title}</TableCell>
                            <TableCell align="right">
                              {addCommas(dataRowDetail?.[`${item.data}`])}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={1}
            sx={{ marginTop: '10px', textAlign: 'center' }}
          >
            <Grid item xs={12}>
              <Button
                variant="contained"
                sx={{ color: 'white' }}
                onClick={() => eDocument.main(Doctype.E_INVOICE)}
              >
                <div className="mr-3">
                  <DownloadIcon />
                </div>
                {Doctype.E_INVOICE.NAME}
              </Button>

              <Button
                variant="contained"
                sx={{ color: 'white', marginLeft: 4 }}
                onClick={() => eDocument.main(Doctype.E_RECEIPT)}
              >
                <div className="mr-3">
                  <DownloadIcon />
                </div>
                {Doctype.E_RECEIPT.NAME}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <NotiAlertListDocument
          open={openListDocuments}
          document={listDocuments}
          selectedRows={dataRowDetail?.result}
          onButtonClick={eDocument.closeDoc}
          titleDocument={titleDocument}
          downLoadZip={eDocument.downLoadZip}
        />
      </Box>
    </Modal>
  );
}

export default DrawerHistory;
